<template>
    <div>
        <h4>Welcome, {{displayName}}</h4>
        <div>Please click on a session to join it, or create a new one.</div>
        <br />
        <SessionCreate @created="onSessionCreated" />
        <SessionList :userId="$store.getters.user.userId" @selectSession="joinSession" />
    </div>
</template>

<script>
import SessionList from "@/components/SessionList";
import SessionCreate from "@/components/SessionCreate"

export default {
    name: "ProducerDashboard",
    props: {
        displayName: {
            type: String,
            required: true
        }
    },

    methods: {
        onSessionCreated(session) {
            this.joinSession(session.sessionId);
        },

        joinSession(id) {
            this.$store.dispatch("joinSession", id);
        },
    },

    components: {
        SessionList,
        SessionCreate
    },
};
</script>